import { z } from "zod";
import { SAV_INTERVENTION_NATURES, SAV_INTERVENTION_RESULTATS } from "../../../../enums.js";

/**
 * Une intervention = un point demandé (vérifier la tranchée, réparer le
 * plafond, poser un diagnostic). Pas de liste type : le poseur en ajoute
 * autant que la demande en contient. L'id est un nanoid côté client : ses
 * photos et vidéos lui sont liées par légende (`slot:interventions.<id>.*`),
 * jamais par index, puisqu'un index bouge à la suppression d'une ligne.
 */
export const savInterventionSchema = z.object({
  id: z.string(),
  intitule: z.string().optional(),
  nature: z.enum(SAV_INTERVENTION_NATURES).optional(),
  resultat: z.enum(SAV_INTERVENTION_RESULTATS).optional(),
  observations: z.string().optional(),
});
export type SavIntervention = z.infer<typeof savInterventionSchema>;

export const savInterventionsSchema = z.array(savInterventionSchema);
export type SavInterventions = z.infer<typeof savInterventionsSchema>;
